import { KeenSliderInstance } from 'keen-slider';
import { KeenSliderHooks } from 'keen-slider/react';
import { MutableRefObject } from 'react';
import classNames from 'classnames';
interface Props {
  instanceRef: MutableRefObject<KeenSliderInstance<object, object, KeenSliderHooks> | null>; //@typescript-eslint/ban-types
  currentSlide: number;
}
const Dots = ({
  instanceRef,
  currentSlide
}: Props) => {
  return <div className='absolute bottom-0 left-1/2 flex -translate-x-1/2 items-center justify-center pb-2 lg:pb-4' data-sentry-component="Dots" data-sentry-source-file="dots.tsx">
            {[...Array(instanceRef.current?.track.details.slides.length).keys()].map(idx => {
      return <span key={idx} onClick={() => {
        instanceRef.current?.moveToIdx(idx);
      }} className={classNames('ml-1 cursor-pointer border-0', {
        'h-1 w-1 rounded-[1px] bg-gray-500': currentSlide !== idx
      }, {
        'h-1.5 w-4 rounded-sm bg-surface-scrim-white': currentSlide === idx
      })} />;
    })}
        </div>;
};
export default Dots;